export default "__VITE_ASSET__DAgDDbb4__"